module.exports = __webpack_public_path__ + "img/img61.973a73c8.png";